<template>
  <div>
    <h2 v-if="!compact" class="mc-h2">Damage and repair</h2>
    <p v-if="!compact" class="mc-lede">
      Tap every part of your vehicle that was damaged.
    </p>
    <chip-group
      :options="AREAS"
      :value="value.areas"
      multi
      @input="update('areas', $event)"
    />

    <h3 class="mc-h3">How severe is it?</h3>
    <chip-group
      :options="SEVERITY"
      :value="value.severity"
      @input="update('severity', $event)"
    />

    <div class="mc-field mc-mt24">
      <label class="mc-lbl" for="mc-preex"
        >Pre-existing damage (optional)</label
      >
      <input
        id="mc-preex"
        type="text"
        placeholder="Anything already damaged before this accident"
        :value="value.preex"
        @input="update('preex', $event.target.value)"
      />
    </div>

    <div class="mc-field">
      <label class="mc-lbl" for="mc-dd"
        >Describe the damage <span class="mc-req">*</span></label
      >
      <textarea
        id="mc-dd"
        placeholder="Anything an assessor should know before they see the vehicle"
        :value="value.damageDesc"
        @input="update('damageDesc', $event.target.value)"
      />
      <p class="mc-hint">
        <span v-if="value.damageDesc.trim().length < 10" class="is-err">
          Please describe the damage — at least a short sentence.
        </span>
        <template v-else
          >Thanks — that gives the assessor a head start.</template
        >
      </p>
    </div>

    <h3 class="mc-h3">Where should we assess the vehicle?</h3>
    <option-card
      v-for="a in ASSESS"
      :key="a.id"
      :title="a.t"
      :subtitle="a.s"
      :selected="value.assess === a.id"
      @click="update('assess', a.id)"
    />
    <div v-if="value.assess === 'a5'" class="mc-field mc-mt8">
      <label class="mc-lbl" for="mc-addr">Address for the assessor</label>
      <input
        id="mc-addr"
        type="text"
        placeholder="Estate, road, landmark"
        :value="value.assessAddr"
        @input="update('assessAddr', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
import ChipGroup from '../shared/ChipGroup.vue'
import OptionCard from '../shared/OptionCard.vue'

const AREAS = [
  'Front bumper',
  'Bonnet',
  'Windscreen',
  'Right headlight',
  'Left headlight',
  'Right side',
  'Left side',
  'Rear bumper',
  'Boot / tailgate',
  'Roof',
  'Wheels',
  'Undercarriage',
]
const SEVERITY = ['Minor', 'Moderate', 'Severe']
const ASSESS = [
  {
    id: 'a1',
    t: 'APA Assessment Centre (Nairobi)',
    s: 'Usually the fastest — assessment and approval in one visit.',
  },
  {
    id: 'a5',
    t: 'At an address I’ll give you',
    s: 'We’ll send an assessor to wherever the vehicle is.',
  },
]

export default {
  name: 'DamageStep',
  components: { ChipGroup, OptionCard },
  props: {
    // { areas: [], severity, preex, damageDesc, assess, assessAddr }
    value: { type: Object, required: true },
    // rendered inside a review card, which already supplies the heading
    compact: { type: Boolean, default: false },
  },
  data() {
    return { AREAS, SEVERITY, ASSESS }
  },
  methods: {
    update(key, val) {
      this.$emit('input', { ...this.value, [key]: val })
    },
  },
}
</script>

<style scoped>
.mc-h2 {
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #14142b;
}

.mc-h3 {
  font-size: 13px;
  font-weight: 600;
  margin: 22px 0 10px;
  color: #3d4450;
}

.mc-lede {
  font-size: 14.5px;
  color: #6e7191;
  margin: 0 0 20px;
}

.mc-req {
  color: #eb5757;
}

.mc-field {
  margin: 0 0 16px;
}

.mc-mt24 {
  margin-top: 24px;
}

.mc-mt8 {
  margin-top: 8px;
}

.mc-lbl {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3d4450;
  margin-bottom: 7px;
}

input,
textarea {
  width: 100%;
  font-family: inherit;
  font-size: 16px;
  color: #333333;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 13px 14px;
}

textarea {
  min-height: 104px;
  resize: vertical;
  line-height: 1.55;
}

input:focus,
textarea:focus {
  outline: 0;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.13);
}

.mc-hint {
  font-size: 12.5px;
  color: #6e7191;
  margin: 6px 0 0;
}

.mc-hint .is-err {
  color: #eb5757;
  font-weight: 500;
}
</style>
